<template>
  <div id="particles-js">
    <slot />
  </div>
</template>

<script>
import config from '@/plugins/particles/particlesjs-config.json'
export default {
  name: 'ParticlesJS',
  data () {
    return {
      config
    }
  },
  mounted () {
    require('particles.js')
    this.$nextTick(() => {
      this.initParticlesJS()
    })
  },
  methods: {
    initParticlesJS () {
      window.particlesJS('particles-js', config)
    }
  }
}
</script>

<style scoped>

</style>
